module.exports = __webpack_public_path__ + "static/media/noimg-470x240.1776a1ba.jpg";